import { CommonResponse } from 'models/common';
import axiosClient from 'utils/axiosClient';
import { MenuServingTimeDetailItem, MenuServingTimeItemList } from './model/MenuServingTime';

const menuServingTimeService = {
  getList(): Promise<CommonResponse<MenuServingTimeItemList[]>> {
    const url = `/menu-serving-times`;
    return axiosClient.get(url);
  },
  updateList(payloads: Partial<MenuServingTimeItemList>[]): Promise<CommonResponse<MenuServingTimeItemList[]>> {
    const url = `/menu-serving-times`;
    return axiosClient.patch(url, payloads);
  },
  delete(payloads: Partial<MenuServingTimeItemList>[]): Promise<CommonResponse<MenuServingTimeItemList[]>> {
    const url = `/menu-serving-times`;
    return axiosClient.delete(url, { data: payloads });
  },
  getItem(params: number): Promise<CommonResponse<MenuServingTimeDetailItem>> {
    const url = `/menu-serving-time?id=${params}`;
    return axiosClient.get(url);
  },
  createItem(payload: Partial<MenuServingTimeDetailItem>): Promise<CommonResponse<MenuServingTimeDetailItem>> {
    const url = `/menu-serving-time`;
    return axiosClient.post(url, payload);
  },
  updateItem(payload: Partial<MenuServingTimeDetailItem>): Promise<CommonResponse<MenuServingTimeDetailItem>> {
    const url = `/menu-serving-time`;
    return axiosClient.patch(url, payload);
  },
};

export default menuServingTimeService;
